/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { AiUserFeedbackControllerFindByIdQueryResponse, AiUserFeedbackControllerFindByIdPathParams, AiUserFeedbackControllerFindById401, AiUserFeedbackControllerFindById404 } from "../../models/aiUserFeedbackController/AiUserFeedbackControllerFindById";

function getAiUserFeedbackControllerFindByIdUrl(id: AiUserFeedbackControllerFindByIdPathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/ai-user-feedback/${id}` as const }  
  return res
}

/**
 * @summary Get feedback by ID
 * {@link /api/v1/ai-user-feedback/:id}
 */
export async function aiUserFeedbackControllerFindById(id: AiUserFeedbackControllerFindByIdPathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<AiUserFeedbackControllerFindByIdQueryResponse, ResponseErrorConfig<AiUserFeedbackControllerFindById401 | AiUserFeedbackControllerFindById404>, unknown>({ method : "GET", url : getAiUserFeedbackControllerFindByIdUrl(id).url.toString(), ... requestConfig })  
  return res.data
}